import React, { useRef, useState } from "react";

const RoomDarkeningShades = () => {
  const whatWeOfferRef = useRef(null);
  
  const scrollToSection = () => {
    if (whatWeOfferRef.current) {
      whatWeOfferRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  const [faqOpen, setFaqOpen] = useState(null);

  const toggleFaq = (index) => {
    setFaqOpen(faqOpen === index ? null : index);
  };

  const faqs = [
    {
      question: "What are room darkening shades?",
      answer: "Room darkening shades are window treatments designed to block a significant amount of natural light. They provide privacy and help reduce glare, making them ideal for bedrooms, media rooms, or any area where you want to control the amount of light.",
    },
    {
      question: "Can I customize the size and style?",
      answer: "Yes, room darkening shades can be fully customized to fit your window dimensions. You can choose from a variety of styles, fabrics, and colors to match your décor. Some options include motorized control systems for added convenience.",
    },
    {
      question: "Are these shades energy-efficient?",
      answer: "Yes, room darkening shades can improve energy efficiency by insulating your windows. They help regulate room temperatures, keeping your space cooler in summer and warmer in winter, which can reduce heating and cooling costs.",
    },
  ];

  return (
    <div className="bg-white font-playfair">
      {/* <section
        className="text-center object-cover h-screen bg-cover bg-center"
        style={{ backgroundImage: "url('images/bright1.jpeg')" }}
      >
        <div className="px-8 md:px-0 lg:px-28">
          <h1 className="text-4xl md:text-7xl text-left font-Montserrat uppercase font-semibold mb-4 xl:text-9xl pl-4 sm:pl-16 lg:pl-40 pt-32 text-[#ffffff]">
          OFFERING PRIVACY
          </h1>

          <h1 className="text-4xl md:text-7xl text-right font-Montserrat uppercase font-semibold mb-4 xl:text-9xl pr-4 sm:pr-16 lg:pr-40 text-[#ffffff]">
            & PEACEFUL AMBIANCE
          </h1>
        </div>

        <div className="flex justify-center mt-8 sm:mt-16 lg:mt-24">
          <button onClick={scrollToSection} className="text-black bg-[#ffffff] text-xl px-6 py-3 ">
            LEARN MORE
          </button>
        </div>
      </section> */}

<section 
   className="object-cover h-screen bg-cover bg-center flex flex-col  items-center  pt-40 md:pt-20 "
   style={{ backgroundImage: "url('images/bright1.jpeg')" }}
 >
  <div className="">
    <h1 className="text-4xl md:text-8xl 2xl:text-[130px] font-semibold text-[#ffffff] font-Montserrat uppercase  mb-4  lg:text-8xl ">
    ROOM 
    </h1>
    <h1 className="text-4xl md:text-8xl 2xl:text-[130px] font-semibold text-[#ffffff] font-Montserrat uppercase  mb-4  lg:text-8xl">
      DARKENING
    </h1>
  </div>

  {/* Button positioned below the text */}
  <div className="mt-4 2xl:mt-6 flex justify-center  ">
    <button onClick={scrollToSection} className="text-black bg-[#ffffff] 2xltext-xl w-40 2xl:w-48 px-6 py-2">
      LEARN MORE
    </button>
  </div>
</section>
      <section className="py-16 px-2 md:px-6">
  <h2 ref={whatWeOfferRef} className="text-3xl md:text-5xl lg:text-7xl font-bold text-center mb-10 md:mb-20 ">
  Transform Your Space<br/> with Room Darkening Shades
  </h2>
  <div className="flex flex-col gap-20 xl:gap-40">
    {/* Benefit 1 */}
    <div className="flex flex-col lg:flex-row gap-20 md:gap-5 items-center justify-arround">
      <div className="w-full max-w-xl xl:max-w-3xl mx-auto">
        <h3 className="text-2xl md:text-5xl xl:text-6xl font-medium mb-8">Maximized Privacy</h3>
        <p className="text-gray-600 text-xl  md:text-2xl xl:text-4xl text-justify">
        Room darkening shades are the perfect solution for maximizing privacy.
         Whether you're in a busy neighborhood or want to create a peaceful sanctuary, 
         these shades block outside visibility while letting in controlled light.
        </p>
      </div>
      <div className="w-full ">
        <img
          className="mx-auto w-full md:w-3/4 xl:w-3/4 h-[300px] md:h-[400px] lg:h-[500px] object-fit"
          src="images/roomdark.webp"
          alt="Effortless Morning Comfort"
        />
      </div>
    </div>

    {/* Benefit 2 */}
    <div className="flex flex-col lg:flex-row-reverse gap-20 md:gap-5 items-center justify-between">
      <div className="w-full  max-w-xl xl:max-w-3xl mx-auto">
        <h3 className="text-2xl md:text-5xl xl:text-6xl font-medium mb-8 text-center">Total Light Control</h3>
        <p className="text-gray-600 text-xl md:text-2xl xl:text-3xl text-justify">
        These shades allow you to control the amount of natural light that enters your room.
         Adjust them to block out light for a restful sleep or let in a soft glow to create a warm 
         and inviting atmosphere.
        </p>
      </div>
      <div className="w-full ">
        <img
          className="mx-auto w-full md:w-3/4 xl:w-3/4 h-[300px] md:h-[400px] lg:h-[500px] object-fit"
          src="images/roomdark3.jpg"
          alt="Customized Comfort Throughout the Day"
        />
      </div>
    </div>

    {/* Benefit 3 */}
    <div className="flex flex-col lg:flex-row gap-20 md:gap-5 items-center justify-between">
      <div className="w-full max-w-xl xl:max-w-3xl mx-auto">
        <h3 className="text-2xl md:text-5xl xl:text-6xl font-medium mb-8 text-center">Energy Efficiency</h3>
        <p className="text-gray-600 text-xl md:text-2xl xl:text-3xl text-justify">
        Room darkening shades are not only about aesthetics—they’re also energy-efficient. 
        They help to keep your home cooler in the summer and warmer in the winter by providing an
         extra layer of insulation.
        </p>
      </div>
      <div className="w-full ">
        <img
          className="mx-auto w-full md:w-3/4 xl:w-3/4 h-[300px] md:h-[400px] lg:h-[500px] object-fit"
          src="images/roomdark2.jpg"
          alt="Evening Elegance"
        />
      </div>
    </div>
  </div>
</section>

      {/* FAQ Section */}
      <section className="py-10 px-6 sm:px-8 lg:px-60 font-playfair">
        <h3 className="text-3xl md:text-6xl font-semibold text-center text-gray-800 mb-6">
          Frequently Asked Questions
        </h3>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-zinc-100 p-8 rounded-lg shadow-sm cursor-pointer"
              onClick={() => toggleFaq(index)}
            >
              <div className="flex justify-between items-center">
                <h4 className="text-lg sm:text-2xl font-semibold text-gray-800">
                  {faq.question}
                </h4>
                <span className="text-gray-500">
                  {faqOpen === index ? "-" : "+"}
                </span>
              </div>
              {faqOpen === index && (
                <p className="mt-2 text-gray-600">{faq.answer}</p>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* Call-to-Action */}
      <section
        className="relative bg-cover bg-center py-24 sm:py-32 mt-20"
        style={{ backgroundImage: "url('images/landing.png')" }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <div className="relative z-10 container mx-auto text-center text-white px-6">
          <h2 className="text-4xl sm:text-5xl font-bold mb-6">Elevate Your Space with Custom Blinds</h2>
          <p className="text-lg sm:text-xl mb-8">
            Enhance your home with the perfect balance of privacy, light control, and energy efficiency. Contact us today!
          </p>
          <a
            href="/contact"
            className="inline-block bg-[#ac9b82] text-white font-semibold px-8 py-3 rounded-full shadow-lg hover:bg-[#9e7f52] transition duration-300"
          >
            Request Your Free Quote
          </a>
        </div>
      </section>
    </div>
  );
};

export default RoomDarkeningShades;
